import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface ExperimentEligibilityState {
    ineligibilityProperties: {
        accept?: string;
        acceptLanguage?: string;
        cfBotScore?: number;
        userAgent?: string;
    };
    ineligibilityReason: string | null;
    isEligibleForAssignment: boolean | null;
}

interface ExperimentEligibilityAction {
    experimentEligibility: ExperimentEligibilityState;
}

const initialState = {
    ineligibilityProperties: {},
    ineligibilityReason: null,
    isEligibleForAssignment: null,
} satisfies ExperimentEligibilityState as ExperimentEligibilityState;

const experimentEligibilitySlice = createSlice({
    initialState,
    name: 'experimentEligibility',
    reducers: {
        experimentEligibilityReceived(state, action: PayloadAction<ExperimentEligibilityAction>) {
            const { experimentEligibility } = action.payload;

            state.isEligibleForAssignment = experimentEligibility.isEligibleForAssignment;
            state.ineligibilityReason = experimentEligibility.ineligibilityReason;
            state.ineligibilityProperties = experimentEligibility.ineligibilityProperties;
        },
    },
    selectors: {
        selectExperimentEligibility: (state: ExperimentEligibilityState) => state,
    },
});

export const { actions, selectors } = experimentEligibilitySlice;
export const { experimentEligibilityReceived } = actions;
export default experimentEligibilitySlice.reducer;
